module.exports = __webpack_public_path__ + "img/5.e2e90f38.jpg";